import React from "react";
import {View, StyleSheet} from "react-native";
import PtText from "../../core/pt-text/pt-text";
import {styleVars} from "../../../app-style-vars";
import { getTranslation } from "../../../helpers/getTranslation";
import {PtOrderStatusIndicatorProps} from './pt-order-status-indicator-props';

export default function PtOrderStatusIndicator(props: PtOrderStatusIndicatorProps) {

  const statusCode = props.statusCode;
  const statusText = getTranslation(`order.history.status.${statusCode}`);

  const indicatorColor = () => {
    switch (statusCode) {
      case 'inAnalysis': { return styleVars.boschLightGray }
      case 'open': {return styleVars.boschLightGray}
      case 'notRelevant': {return styleVars.boschLightGray}
      case 'rejected': {return styleVars.boschLightGray}
      case 'inProgress': {return styleVars.boschYellow}
      case 'inTransit': {return styleVars.boschYellow}
      case 'inShipment': {return styleVars.boschYellow}
      case 'billed': {return styleVars.boschYellow}
      case 'delivered': {return styleVars.boschLightGreen}
      case 'notYetProcessed': {return styleVars.boschLightGray}
      case 'partiallyProcessed': {return styleVars.boschYellow}
      case 'completelyProcessed': {return styleVars.boschLightGreen}
      case 'complete': {return styleVars.boschLightGreen}

      default: return styleVars.boschLightGray
    }
  }


  const styles = StyleSheet.create({
    orderStatusIndicatorContainer: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    orderStatusIndicator: {
      width: styleVars.rem(.75),
      height: styleVars.rem(.75),
      borderRadius: styleVars.rem(.375),
      backgroundColor: indicatorColor(),
    },
    orderStatusIndicatorTextContainer: {
      paddingLeft: styleVars.rem(.5),
    },
    orderStatusIndicatorText: {
      fontSize: styleVars.rem(.75),
      color: indicatorColor()
    }
  });


  return (
    <View style={[styles.orderStatusIndicatorContainer]}>
      <View style={[styles.orderStatusIndicator, indicatorColor]}></View>
      <View style={[styles.orderStatusIndicatorTextContainer]}>
        <PtText style={[styles.orderStatusIndicatorText]}>
          {statusText}
        </PtText>
      </View>
    </View>
  )
}